// TODO:
// should only log error in dev mode
export const warn = (message) => {
  console.error(message);
};
